export const AUTH_REQUEST = 'AUTH_REQUEST'
export const WEBAUTHN_REQUEST = 'WEBAUTHN_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const CHECK_AUTH = 'CHECK_AUTH'
